import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextHtml } from 'ui';

const PrivacyPolicy = () => {
  const { t } = useTranslate();
  const scopes = useSelector((state) => coreEntities.langs.selectors.getLangScopes(state));
  const [privacy, setPrivacy] = useState('');
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  useEffect(() => {
    if (scopes && scopes.length > 0) {
      let privacyScope = scopes.filter((scope) => scope.scope === 'privacy');
      if (privacyScope && privacyScope.length > 0) {
        setPrivacy(privacyScope[0].json);
      }
    }
  }, [scopes]);

  useEffect(() => {
    if (privacy?.endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, [privacy]);

  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="sr-only">{t('titles:Privacy')}</h1>
      {showPdfViewer ? (
        <PdfViewerFullScreen ariaLabel={t('titles:Privacy')} url={privacy} />
      ) : (
        <div style={{ padding: '40px' }}>
          <TextHtml text={privacy} />
        </div>
      )}
    </main>
  );
};

export default PrivacyPolicy;
